import moment from 'moment';

export const defaultAppointment = {
    id: 0,   
    clientId: null,
    doctorId: null,
    activityId: null,
    dateTime: null,
    note:'',
    notify:false
}
